const prefix = 'drivex/tags';

const LOAD_CUSTOMERS_TAGS_SUCCESS = `${prefix}/LOAD_CUSTOMERS_TAGS_SUCCESS`;
const LOAD_CUSTOMER_TAG_SUCCESS = `${prefix}/LOAD_CUSTOMER_TAG_SUCCESS`;

export default {
  LOAD_CUSTOMERS_TAGS_SUCCESS,
  LOAD_CUSTOMER_TAG_SUCCESS
};
